// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2-zcN","modalFooterButton":"ModalNotes_modalFooterButton__1LAmo"};